import { gql } from "@apollo/client";

export const GET_USER_SUPPORT_TICKETS = gql`
  query GetSingleUserSupportTickets($input: SingleUserSupportTicketsInput!) {
    getSingleUserSupportTickets(input: $input) {
      tickets {
        _id
        title
        description
        status
        category
        orderId
        otherDetails
        createdAt
        updatedAt
        user {
          _id
          name
          email
        }
      }
      docsCount
      totalPages
      currentPage
    }
  }
`;

export const GET_SINGLE_SUPPORT_TICKET = gql`
  query GetSingleSupportTicket($ticketId: ID!) {
    getSingleSupportTicket(ticketId: $ticketId) {
      _id
      title
      description
      status
      category
      orderId
      otherDetails
      createdAt
      updatedAt
      user {
        _id
        name
        email
        phone
      }
    }
  }
`;

export const CREATE_SUPPORT_TICKET = gql`
  mutation CreateSupportTicket($ticketInput: SupportTicketInput!) {
    createSupportTicket(ticketInput: $ticketInput) {
      _id
      title
      description
      status
      category
      orderId
      otherDetails
      createdAt
      updatedAt
      user {
        _id
        name
        email
      }
    }
  }
`;
